<template>
  <div style="margin-top: 4rem">
    <div class="swiper-container" id="banner" :style="hight">
      <div class="swiper-wrapper">
        <img class="swiper-slide"
             v-for="banner in banners"
             :src="banner.imgUrl"
             @click="goToRecommend(banner)"
             v-if="!banner.imgUrlProduct && banner.param"/>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
  import 'swiper/dist/css/swiper.min.css';
  import Swiper from 'swiper/dist/js/swiper.min.js';
  export default{
    name:'banner',
    props:['banners'],
    components:{

    },
    data(){
      return {
        imgs:[],
//        hight:{'margin-top':'7.5rem'}
        hight:{'margin-top':'-1rem'},
        jdOpenUrlArrayStr:""
      }
    },
    created(){
      this.public.clearParam();
      let seft = this;
      this.banners.forEach(function(item){
        item.imgUrlT ? seft.imgs.push(item.imgUrlT) : seft.imgs.push(item.imgUrl);
        item.classType == seft.classType.JDBanner && function(){seft.jdOpenUrlArrayStr = item.openUrl}();
      });
    },
    mounted(){
      let seft = this;
      this.watcher.$on('closeHeader',function(type){
        if(type==seft.showType.H5){
          seft.hight = {'margin-top':'3rem'};
        }
      });
      new Swiper('#banner', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        slidesPerView: 'auto',
        autoplay:3000,
        speed:1000,
        autoplayDisableOnInteraction:0
      });
    },
    methods:{
      goToRecommend(banner){
        if(banner.idx == 1555){
          location.href = banner.openUrl;
        }else if(banner.classType===this.classType.JDBanner){
          var param = "?openUrl="+this.jdOpenUrlArrayStr;
          this.jumpToView(this.headType.JDBanners,param,banner.title);
        }else if(banner.classType===this.classType.newBanner) {
          location.href=banner.desc;
        }else{
          this.jumpToView(this.headType.recommend,banner.param,banner.title);
        }
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Banner.vue?1f3aa644